import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_credit_note } from "../../../components/Report.js";
export default class DebtReduces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",

      data: [],
      data_customer: [],
      data_invoice: [],
      count: 10,

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
      customer_id: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date } = this.state;
    let data, count, data_customer;
    loading(true);
    let [result, result_customer] = await Promise.all([
      GET("admin/credit-notes/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
      }),
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    this.setState({
      data,
      count,
      data_customer,
    });
    loading(false);
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบรายการนี้หรือไม่ ?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("banks/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create,
      filter_search,
      filter_start_date,
      filter_end_date,
      data,
      data_customer,
      data_invoice,
      count,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
      customer_id,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">ใบลดหนี้</h4>

              <button
                className="btn btn-dark px-4 mb-3"
                onClick={() => {
                  window.location.href = "/invoice/payment-debt-reduces";
                }}
              >
                สร้างใบลดหนี้
              </button>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่ส่งสินค้า</td>
                    <td className="text-nowrap">รหัสเอกสาร</td>
                    <td className="text-nowrap">เอกสารอ้างอิง</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">จำนวนเงิน (บาท)</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.document_no || ""}</td>
                      <td className="text-nowrap">{item.invoice?.sale?.document_no || ""}</td>
                      <td className="text-nowrap">
                        {item.invoice?.sale?.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap">{toFixed(item.amount)}</td>
                      <td className="text-nowrap">{item.status}</td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          {/* <BtnIcon type="view" onClick={() => {}} /> */}
                          {item.status === "รอชำระ" && (
                            <BtnIcon
                              type="update"
                              onClick={() => {
                                window.location.href =
                                  "/invoice/payment-invoices?id=" + item.uid;
                              }}
                            />
                          )}
                          <BtnIcon type="print" onClick={() => {
                            report_credit_note(item.uid,{ref_number:item.invoice?.uid})
                          }} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
